import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, ComPhoto } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:소매상세정보
 * 세부설명:
*/

export class RtiDtl extends Component {
    static displayName = RtiDtl.name;
    constructor(props) {
        super(props);
        this.state = {
            RetailInfo:[]
        };
        this.handleConfirm_Click = this.handleConfirm_Click.bind(this);
        this.handelList_Click = this.handelList_Click.bind(this);

        this.Union_Uid = "";
    }
    //초기화
    componentDidMount() {
        this.CallRetailInfoData();
    }
    async handleConfirm_Click(event,union_uid) {
        try {
            let Data = await Big3Common.Get(`api/Retail/RetailMgr/SetRetailGrupConfirm/${union_uid}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleConfirm_Click: ", e)
        }
        event.preventDefault();
    }
    handelList_Click(modalID) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["RetailInfo"]);
        this.props.RenderComponent('RequestList', StateCopy);
        return false;
    }
    async CallRetailInfoData() {
        try {
            if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
                this.Union_Uid = this.props.ContentState.Union_Id;
                let Data = await Big3Common.Get(`api/Retail/RetailMgr/GetRetailInfoToNote/${this.Union_Uid}`);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let RetailInfo = JSON.parse(Data.dataTable);
                    this.setState({ RetailInfo: RetailInfo });   
                }
                else {
                    console.log(Data.message);
                }
            }
        }
        catch (e) {
            console.log("CallRetailInfoData: ", e)
        }
        return false;
    }
    render() {
        if (this.state.RetailInfo.length > 0) {
            let Retail = this.state.RetailInfo[0];
            let address1 = Retail.retail_addr_1 === null ? "" : Retail.retail_addr_1;
            let address2 = Retail.retail_addr_2 === null ? "" : Retail.retail_addr_2;
            return (
                <div className="container_box d_padding p_margin">
                    <div className="retail_info">
                        <div className="retail_photo_box">
                            <ComPhoto className="retail_photo" Photo={Retail.retail_photo} />
                        </div>
                        <div className="retail_order_info">
                            <div className="retail_name">{Retail.retail_org_name}</div>
                            <div className="retail_info_txt retail_add">{Retail.retail_area_nm}</div>
                            <div className="retail_info_txt">Clo:D 거래액 : {Big3Common.Util.Money(Retail.mon_trunover)}원</div>
                            <div className="retail_info_txt">Clo:D 주문수 :  {Big3Common.Util.Money(Retail.mon_ordnumber)}건</div>
                            <Link to={`/Order/LiveChat/Index?union_uid=${this.Union_Uid}`}>
                                <div className="chat_icon"></div>
                            </Link>
                        </div>
                    </div>
                    <div className="business_info_box">
                        <div className="business"><div className="business_number_icon"></div><div className="business_title">사업자번호</div></div>
                        <div className="business_info">{Retail.retail_org_no}</div>
                    </div>
                    <div className="business_info_box">
                        <div className="business"><div className="business_address_icon"></div><div className="business_title">사업자주소</div></div>
                        <div className="business_info">{address1 + " " + address2}</div>
                    </div>
                    {
                        Retail.appr_status === "WA" ?
                            <div className="retail_btn">
                                <button type="button" className="r_btn_v btn_v1" onClick={(e) => this.handleConfirm_Click(e,Retail.union_uid)}>거래승인</button>
                            </div>
                            : ""
                    }
                    <Alert
                        id="AlertBox"
                        title="승인되었습니다."
                        AlertClick={this.handelList_Click }
                    />
                </div>
            );
        }
        else {
            return null;
        }
        
    }
}
